const key = 'monoai.studio.provider';

export function selectStudioProvider(provider: 'google' | 'microsoft') {
  sessionStorage.setItem(key, provider);
}

export function applyStudioProvider(authorizationUri: string): string {
  const url = new URL(authorizationUri);
  if (url.origin !== window.location.origin || url.pathname !== '/api/monoai/studio/start') {
    return authorizationUri;
  }
  const provider = sessionStorage.getItem(key);
  sessionStorage.removeItem(key);
  if (provider !== 'google' && provider !== 'microsoft') {
    throw new Error('Choose a Studio provider');
  }
  url.searchParams.set('provider', provider);
  return url.href;
}
